import { h } from '../../../../src/shared/components/dom.js';

export const PREFS_KEY = 'nesplay-library-prefs';

export const DEFAULT_PREFS = { version: 1, discovery: { trending: false } };

export const DISCOVERY_MODULES = [
  { id: 'trending', label: 'Trending games', description: 'Most-played games this week' },
];

export function makeToggle(label, active, onChange) {
  return h('button', {
    type: 'button',
    class: `lib-sidebar-toggle${active ? ' active' : ''}`,
    // role="switch" only allows aria-checked for its state — aria-pressed
    // (the role="button" toggle-state attribute) is invalid here per the
    // ARIA spec and axe's aria-allowed-attr rule flags it as a critical
    // violation the moment this control is actually on screen for a scan.
    role: 'switch',
    'aria-checked': active ? 'true' : 'false',
    onclick: () => onChange(!active),
  },
    h('span', { class: 'lib-sidebar-toggle-box' }, active ? '\u2713' : ''),
    h('span', { class: 'lib-sidebar-toggle-label' }, label),
  );
}
